module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-default-logotype.9b8d14d3.svg";